import Head from 'next/head';
import type { JsonLdGraph, JsonLdObject } from '@/constants/jsonld/common';

type JsonLdProps = {
    data: JsonLdGraph | JsonLdObject;
    id: string;
};

const escapeJsonForHtml = (json: string) =>
    json
        .replace(/&/g, '\\u0026')
        .replace(/</g, '\\u003c')
        .replace(/>/g, '\\u003e')
        .replace(/\u2028/g, '\\u2028')
        .replace(/\u2029/g, '\\u2029');

const JsonLd = ({ data, id }: JsonLdProps) => {
    const jsonString = JSON.stringify(data);

    if (!jsonString) {
        return null;
    }

    return (
        <Head>
            <script
                id={id}
                key={id}
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: escapeJsonForHtml(jsonString),
                }}
            />
        </Head>
    );
};

export default JsonLd;
